import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { DefaultProductApiRequest, DefaultProductLink, DefaultProductsLinks, DefaultProduct } from './socialStreamDefaultProductsApiRequestHelper'

Vue.use(Vuex)

export interface DefaultProductsState {
    dataLoading: boolean,
    instanceId: string,
    catalogId: string,
    linkedIds: Array<string>,
    linkedProducts: Object,
}

const getInitialState = (): DefaultProductsState => ({
    dataLoading: true,
    instanceId: '',
    catalogId: '',
    linkedIds: [],
    linkedProducts: {},
})

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setInstanceId(state: DefaultProductsState, instanceId: string) {
      state.instanceId = instanceId
    },
    setCatalogId(state: DefaultProductsState, catalogId: string) {
      state.catalogId = catalogId
    },
    setLinkedIds(state: DefaultProductsState, ids: Array<string>) {
      state.linkedIds = ids
    },
    setLinkedProducts(state: DefaultProductsState, products: Object) {
      state.linkedProducts = {}
      state.linkedIds = []
      for(const [key, value] of Object.entries(products)){
        state.linkedIds.push(key)
        state.linkedProducts[key as keyof typeof state.linkedProducts] = value
      }
    },
    addLinkedItem(state: DefaultProductsState, product: any) {
      state.linkedIds.push(product.id)
      state.linkedProducts[product.id as keyof typeof state.linkedProducts] = product
    },
    removeLinkedItem(state: DefaultProductsState, id: any) {
      if(state.linkedIds.includes(id)){
        state.linkedIds.splice(state.linkedIds.indexOf(id), 1)
        delete state.linkedProducts[id as keyof typeof state.linkedProducts]
      }
    },
    setDataLoading(state: DefaultProductsState, dataLoading: boolean) {
        state.dataLoading = dataLoading
    }
  },
  actions: {
    addDefaultProduct(context: any, product: any) {
            
      const storeResponse = DefaultProductApiRequest.addDefaultProduct({
        instanceId: context.state.instanceId,
        catalogId: context.state.catalogId,
        productId: product.id,
      })

      return storeResponse
        .then((response: AxiosResponse<any>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          context.commit('addLinkedItem', product)
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('catalogItemsLinker.linkError'), { root: true })
          throw error
        })
    },
    removeDefaultProduct(context: any, productId: string) {
            
      const storeResponse = DefaultProductApiRequest.removeDefaultProduct({
        instanceId: context.state.instanceId,
        catalogId: context.state.catalogId,
        productId: productId,
      })

      return storeResponse
        .then((response: AxiosResponse<any>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          context.commit('removeLinkedItem', productId)
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('catalogItemsLinker.linkError'), { root: true })
          throw error
        })
    },
    getDefaultProducts(context: any) {
        DefaultProductApiRequest.getDefaultProducts(context.state.instanceId).then(results => {
            context.commit('setLinkedProducts', results.data.data)
            context.commit('setDataLoading', false)
        })
    },
  }
})

